import React, {memo} from 'react';

import {Box} from '@mui/material';
import styled from '@emotion/styled';

import {ChatHeader} from '../../components/Chat/ChatHeader';
import {ChatBody} from '../../components/Chat/ChatBody';
import {ChatFooter} from '../../components/Chat/ChatFooter';

import parse from "html-react-parser";
import {useChat} from "../../context/Context";

const ChatStyled = styled(Box)((theme) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
    // backgroundColor: '#fff',
}));

export const Chat = memo(
    ({
         messages,
         channels,
         members,
         sendMessage,
         messagesPreload,
         showRequest,
         onClose,
         showCloseButton,
         onShowRequest,
         isInSchedule,
         onClick,
         onCancel,
         isChatActive,
         isOnline,
         dialogId,
         hasPreloadedMessages,
         messagesLoading,
         sendMessageWithActiveDialog,
     }) => {
        const {defaultLang, titleMessages,} = useChat();

        const OutOFScheduleTitle = titleMessages?.non_work?.greeting[defaultLang];

        return (
            <ChatStyled>
                <ChatHeader
                    managersList={members}
                    isOnline={isOnline}
                    showCloseButton={showCloseButton && !!messages.length}
                    onClose={onClose}
                    onCancel={onCancel}
                    onClick={onClick}
                />
                {isInSchedule ? (
                    <ChatBody
                        messagesLoading={messagesLoading}
                        messagesPreload={messagesPreload}
                        sendMessageWithActiveDialog={sendMessageWithActiveDialog}
                        sendMessage={sendMessage}
                        dialogId={dialogId}
                        onClick={onShowRequest}
                        showRequest={showRequest}
                        messages={messages}
                        hasPreloadedMessages={hasPreloadedMessages}
                        isChatActive={isChatActive}
                    />
                ) : (
                    <OutOFSchedule color="primary.main" message={OutOFScheduleTitle}/>
                )}
                <ChatFooter
                    channels={channels}
                    sendMessage={sendMessage}
                    sendMessageWithActiveDialog={sendMessageWithActiveDialog}
                    showSocials={!messages.length}
                    isInSchedule={isInSchedule}
                    dialogId={dialogId}
                    isChatActive={!isInSchedule}
                    messages={messages}
                />
            </ChatStyled>
        );
    }
);

const OutOFSchedule = ({message}) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                rowGap: '10px',
                padding: '14px',
            }}
        >
            <Box
                sx={(theme) => ({
                    color: 'header.main',
                    width: '100%',
                    p: {
                        fontFamily: theme.typography.fontFamily,
                    }
                })}
            >
                {message ? parse(message) : ''}
            </Box>
        </Box>
    );
};
